import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';

import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';
import { IconDefinition, dom, library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/pro-solid-svg-icons';


if (environment.production) {
  enableProdMode();
}

library.add(...(Object.values(fas) as IconDefinition[]));
dom.watch();

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
